import React from 'react';



const Icon = (props) => {
	const { onKeyDown = (e) => { }, ...restProps } = props
	/*function sendDataToGTM(){
		  //event label remonte les données renseignées lors de Click sur CTA "afficher plus de garages à proximité"
					 window.dataLayer.push({
					  'pageName':"multicréneaux",  
					  'event': 'uaevent',  
					  'eventCategory': 'Content',  
					  'eventAction': "Display::MoreDealers",
					  'eventLabel': window.labels['Multi-creneaux_AfficherPlusGarages'] 
				 }); 
	   props.onClick();
	}*/
	if (typeof restProps.dataImage != "undefined" && restProps.dataImage.length)
		return (
			<i
				tabIndex={restProps.isTabIndexActivate ? '0' : '-1'}
				className={`mark-icons custom-icon ${restProps.className}`}
				style={{ backgroundImage: `url(${restProps.dataImage})` }}
				onClick={restProps.onClick}
				onKeyDown={onKeyDown}>
			</i>
		)
	else
		return (
			<i
				tabIndex={restProps.isTabIndexActivate ? '0' : '-1'}
				className={`mark-icons ${restProps.Name}-icon`}
				onClick={restProps.onClick}
				onKeyDown={onKeyDown}>
			</i>
		)

}

export default Icon;
